// date
import {parseISO, format} from 'date-fns';

const getPublishDate = ({newsArticle, missingDate = '-'}) =>
  !!newsArticle?.published_at
    ? format(parseISO(newsArticle.published_at), 'MMMM d yyyy - h:mm a')
    : missingDate;

export default getPublishDate;
